import { members } from "../data";
import { ArrowLink, PageIntro } from "../components/Shell";

export default function PeoplePage() {
  return (
    <>
      <PageIntro
        label="People"
        title="구성원"
        aside={
          <>
            Current members · {members.length}
            <br />
            정보 기준일 2026-07-23
          </>
        }
      />
      <section className="page-section shell" aria-labelledby="members-heading">
        <div className="section-header">
          <div>
            <p className="section-label">Current members</p>
            <h2 id="members-heading">연구실 구성원</h2>
          </div>
          <ArrowLink to="/alumni">졸업생 보기</ArrowLink>
        </div>
        <div className="directory">
          {members.map((member, index) => (
            <article className="directory-item" key={member.name}>
              <span className="directory-number">{String(index + 1).padStart(2, "0")}</span>
              <h3>{member.name}</h3>
              {member.role ? <p>{member.role}</p> : null}
              {member.interest ? <p>{member.interest}</p> : null}
            </article>
          ))}
        </div>
        <p className="directory-note">
          사진·학위과정·연구 관심사는 구성원 확인 후 공개본에 반영합니다.
        </p>
      </section>
    </>
  );
}
